export default __webpack_public_path__ + "static/media/15.1dabf7f8.jpg";